// ======================================================================
// ERPReportActions.jsx
// Standard ERP Report Actions (Export / Print)
// ======================================================================

import React from "react";

export default function ERPReportActions({ onExport }) {

  return (
    <div className="flex items-center gap-2">

      {/* Excel */}
      <button
        className="erp-secondary-btn"
        onClick={() => onExport("xlsx")}
      >
        ⬇ Excel
      </button>

      {/* PDF */}
      <button
        className="erp-secondary-btn"
        onClick={() => onExport("pdf")}
      >
        ⬇ PDF
      </button>

    </div>
  );
}
